import { useContext } from 'react';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { useSubscriptionTier } from '../../utils/hooks/useSubscriptionTier';
import { FirstTimeFlag } from '../../redux/firstTimeFlags';
import { useFirstTimeFlag } from '../../redux/firstTimeFlags/hooks';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useDeviationViewContext } from '../../Context';
import { DeviationTypes } from '../../types/deviation';
import { getDeviationType } from '../../DeviationViews/_helpers';
export function useSubscriptionLockFTUE(deviation) {
    var isLoggedIn = useContext(SessionContext).isLoggedIn;
    var _a = useSubscriptionTier(deviation), isInTier = _a.isInTier, isOwner = _a.isOwner, isUserSubscribed = _a.isUserSubscribed;
    var _b = useFirstTimeFlag(FirstTimeFlag.IsMsLockedArtNotSeen), isMsLockedArtNotSeen = _b.hasFlag, dropFlag = _b.dropFlag;
    return {
        isSubscriptionLockFTUEShown: !isUserSubscribed &&
            isLoggedIn &&
            isInTier &&
            !isOwner &&
            isMsLockedArtNotSeen,
        dropFlag: dropFlag,
    };
}
export function useSubscriptionLockSidebarFTUE(contentType, deviation) {
    var isMobile = useContext(MobileContext);
    var isTheater = useDeviationViewContext().isTheater;
    var _a = useSubscriptionLockFTUE(deviation), isSubscriptionLockFTUEShown = _a.isSubscriptionLockFTUEShown, dropFlag = _a.dropFlag;
    return {
        isShowingSubscriptionsFTUE: 
        // do we need to show it at all
        isSubscriptionLockFTUEShown &&
            // mobile doesnt get this madness
            !isMobile &&
            // only the in_tiers block gets it
            contentType === 'in_tiers' &&
            // the non-lit ftue relies on having the sidebar on the right and not below, so only in !theater
            ![DeviationTypes.JOURNAL, DeviationTypes.LITERATURE].includes(getDeviationType(deviation)) &&
            !isTheater,
        dropFlag: dropFlag,
    };
}
//# sourceMappingURL=useSubscriptionLockFTUE.js.map